module.exports = __webpack_public_path__ + "assets/img/one-north Business Park.ce5a4a3b.jpg";